module.exports = __webpack_public_path__ + "img/tabs-02.f16c1f08.jpg";